import { render, staticRenderFns } from "./verificationRecord.vue?vue&type=template&id=1fbf1004&scoped=true"
import script from "./verificationRecord.vue?vue&type=script&lang=js"
export * from "./verificationRecord.vue?vue&type=script&lang=js"
import style0 from "./verificationRecord.vue?vue&type=style&index=0&id=1fbf1004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf1004",
  null
  
)

export default component.exports